import React, { lazy, useEffect } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import AuthLayout from '../container/profile/authentication/Index';
import { setNavigate } from '../utility/navigateHandler';
import RecaptchaProvider from '../utility/RecaptchaProvider';

const Eimza = lazy(() => import('../container/eimza/Eimza'));
const Login = lazy(() => import('../container/profile/authentication/overview/SignIn'));
const EDevlet = lazy(() => import('../container/profile/authentication/girisEdevlet/Index'));
const EDevletKontrol = lazy(() => import('../container/profile/authentication/girisEdevlet/overview/EDevletGiris'));

const AuthRoot = () => {
  const navigate = useNavigate();

  useEffect(() => {
    setNavigate(navigate);
  }, [navigate]);

  <div> </div>;

  useEffect(() => navigate('/'));
};

const FrontendRoutes = React.memo(() => {
  return (
    <RecaptchaProvider>
      <Routes>
        <Route index element={<EDevlet />} />
        <Route path="eski" element={<Login />} />
        <Route path="eDevlet" element={<EDevlet />} />
        <Route path="eDevletGiris" element={<EDevletKontrol />} />
        <Route path="ArkSignerIFrameTest" element={<Eimza />} />
        <Route path="*" element={<AuthRoot />} />
      </Routes>
    </RecaptchaProvider>
  );
});

export default AuthLayout(FrontendRoutes);
